import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const ampmeldConfig: TSPConfig = {
  key: 'ampmeld',
  name: 'AMPM ELD',
  imageName: 'AMPMELD',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the username, password, and Company ID from your AMPM ELD profile. The Company ID should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Username',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Enter Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default ampmeldConfig;
